import PlusOutlined from '@ant-design/icons/PlusOutlined'
import CrossIcon from 'Assets/icons/cross-icon.svg'
import InputAttribute from 'Components/attributes/InputAttribute/Input'
import { ATTRIBUTE_TYPES } from 'Constants/attributes.constants'
import { MultiTextAttributeProps } from 'Types/Attribute.types'
import Button from 'antd/lib/button'
import React, { useCallback } from 'react'
import styles from './MultiText.module.less'

const MultiTextAttribute: React.FC<MultiTextAttributeProps> = props => {
    const { onChange, value, label, readonly } = props

    const onCitationChange = useCallback(
        (citations: string[]) => {
            onChange(citations.length ? citations : undefined)
        },
        [onChange]
    )

    const updateCitationValue = useCallback(
        (index: number, str: string | undefined) => {
            if (str !== undefined) {
                const citations = value ?? []
                citations[index] = str
                onCitationChange(citations.filter(Boolean))
            }
        },
        [onCitationChange, value]
    )

    const addCitationInputList = useCallback(() => {
        if (value?.length === 0 || value?.at(-1) === '') {
            return
        }
        const newCitations = [...(value ?? []), '']
        onCitationChange(newCitations)
    }, [onCitationChange, value])

    const removeCitationInputList = useCallback(
        (index: number) => {
            const newCitations = [...(value ?? [])]
            newCitations.splice(index, 1)
            onCitationChange(newCitations)
        },
        [onCitationChange, value]
    )

    return (
        <div className={styles['multiText']} data-testid="multi-text-wrapper">
            <div className={styles['multiText-body']}>
                <div className={styles['label-group']}>
                    <div>{label}</div>
                    <Button
                        onClick={addCitationInputList}
                        type="text"
                        icon={<PlusOutlined />}
                        data-testid="add-citation"
                        disabled={readonly}
                    >
                        Add
                    </Button>
                </div>
                {(props.value?.length ? props.value : [''])?.map((option, index) => (
                    <div className={styles['multiText-body-inner']} key={index}>
                        <InputAttribute
                            value={option}
                            width={'100%'}
                            onChange={(str: string | undefined) => {
                                updateCitationValue(index, str)
                            }}
                            id={'multiText'}
                            label={''}
                            type={ATTRIBUTE_TYPES.INPUT}
                            readonly={readonly}
                        />
                        {index !== 0 && (
                            <button
                                className={styles['multiText-body-button']}
                                onClick={() => {
                                    removeCitationInputList(index)
                                }}
                                data-testid="remove-citation"
                                disabled={readonly}
                            >
                                <img src={CrossIcon} alt="cross-icon" />
                            </button>
                        )}
                    </div>
                ))}
            </div>
        </div>
    )
}

export default MultiTextAttribute
